export var SupportedLocale;
(function (SupportedLocale) {
    SupportedLocale["ENGLISH"] = "en-GB";
    SupportedLocale["DANISH"] = "da";
    SupportedLocale["GERMAN"] = "de";
    SupportedLocale["SPANISH_LATIN_AMERICAN"] = "es-419";
    SupportedLocale["FRENCH"] = "fr";
    SupportedLocale["INDONESIAN"] = "id";
    SupportedLocale["ITALIAN"] = "it";
    SupportedLocale["KOREAN"] = "ko";
    SupportedLocale["MALAY"] = "ms";
    SupportedLocale["DUTCH"] = "nl";
    SupportedLocale["TURKISH"] = "tr";
    SupportedLocale["CHINESE"] = "zh";
    SupportedLocale["CHINESE_TRADITIONAL"] = "zh-TW";
    SupportedLocale["HUNGARIAN"] = "hu";
    SupportedLocale["THAI"] = "th";
    SupportedLocale["PORTUGUESE_BRAZILIAN"] = "pt-BR";
    SupportedLocale["POLISH"] = "pl";
    SupportedLocale["BULGARIAN"] = "bg";
    SupportedLocale["SPANISH_EUROPEAN"] = "es-ES";
})(SupportedLocale || (SupportedLocale = {}));
